module.exports = __webpack_public_path__ + "img/Bear44.9b2444a1.jpg";